module.exports = __webpack_public_path__ + "static/media/copy-to-clipboard.5700098d.svg";